/* eslint-disable no-param-reassign */

import Link from 'gatsby-link';
import React from 'react';
import parse, { domToReact } from 'html-react-parser';

import Blockquote from '../Blockquote';
import Headline from '../Headline';
import Paragraph from '../Paragraph';

const HTML = ({ html }) => {
  const parseOptions = {
    replace: (node) => {
      const defaultTransforms = {
        h2: ({ attribs, children }) => (
          <Headline tag="2" theme="h3" {...attribs}>
            {domToReact(children, parseOptions)}
          </Headline>
        ),

        h3: ({ attribs, children }) => (
          <Headline tag="3" theme="h4" {...attribs}>
            {domToReact(children, parseOptions)}
          </Headline>
        ),

        p: ({ attribs, children }) => (
          <Paragraph {...attribs}>
            {domToReact(children, parseOptions)}
          </Paragraph>
        ),

        blockquote: ({ attribs, children }) => (
          <Blockquote {...attribs}>
            {domToReact(children, parseOptions)}
          </Blockquote>
        ),

        a: ({ attribs, children }) => {
          const { href, ...props } = attribs;

          // TODO: check if the link is internal

          return (
            <Link to={href} {...props}>
              {domToReact(children, parseOptions)}
            </Link>
          );
        },
      };

      if (node.type === 'tag' && defaultTransforms[node.name]) {
        return defaultTransforms[node.name](node);
      }

      return undefined;
    },
  };

  return parse(html || '', parseOptions);
};

export default HTML;
